import { render } from "./RiDel.vue?vue&type=template&id=3b551464"
import script from "./RiDel.vue?vue&type=script&lang=js"
export * from "./RiDel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiDel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b551464"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b551464', __exports__)) {
    api.reload('3b551464', __exports__)
  }
  
  module.hot.accept("./RiDel.vue?vue&type=template&id=3b551464", () => {
    api.rerender('3b551464', render)
  })

}


export default __exports__